interface IUploadSettings {
    enableReuploading: boolean;
}

export const DEFAULT_SETTINGS: IUploadSettings = {
    enableReuploading: false,
};

export const CUSTOM_SETTINGS: {[key: string] : Partial<IUploadSettings>} = {
    truststoreAttachmentFile: {
        enableReuploading: true,
    },
};
